import FirebaseService from './FirebaseService';
import NightingaleService from './NightingaleService';

export default class Application {
  constructor(settings = {}) {
    this.user = settings.user;
    this.firebaseService = new FirebaseService(settings.firebaseService);
    this.nightingaleService = new NightingaleService(settings.nightingaleService);
  }
}



// WEBPACK FOOTER //
// ./src/services/Application.js